import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
// import APP_GETTER_TYPES from '@/js/plugins/store/modules/app/getter-types'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants'
import { loadExternalServices } from '@/js/modules/external-services.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types'

const pollConsent = (store, count) => {
  setTimeout(() => {
    const consent = window?.CookieFirst?.consent || { notfound: count + 1 }
    store.dispatch(`${STORE_MODULES.APP}/${APP_ACTIONS.SET_APP_CONSENT}`, consent)
  }, 2000)
}

export default store => {
  store.watch(
    state => state[STORE_MODULES.APP][APP_CONSTANTS.APP_CONSENT],
    (newValue, oldValue) => {
      if (newValue?.notfound && newValue.notfound < 10) {
        pollConsent(store, newValue.notfound)
      }

      // console.log('app consent watcher', newValue, oldValue)
      loadExternalServices({ i18n: store.$i18n, store, consent: newValue })
    },
  )
}
